import React from "react";
import Layout from "app/components/layouts";
import IncomeDetailsPartOne from "app/components/joint/IncomeDetails/IncomeDetailsPartOne";
import JointStepper from "app/components/common/JointStepper";

const JointIncomeDetails: React.FC = () => {
  return (
    <>
      <Layout>
        <JointStepper />
        <IncomeDetailsPartOne />
      </Layout>
    </>
  );
};

export default JointIncomeDetails;
